import React, { useCallback } from 'react';
import { Delete02Icon, PencilIcon, PinIcon } from 'hugeicons-react';
import { MinimizedChat } from '../../types/chat';
import '../../Styles/Sidebar/ChatDropdown.css';
import { Space } from '../../types/space';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRow,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { EllipsisIcon } from '../../assets/CustomSvgs';

interface SidebarItemDropdownProps {
  chat?: MinimizedChat;
  space?: Space;
  onPinToggle?: (chatId: string) => void;
  onDeleteChat?: (chatId: string) => void;
  onDeleteSpace?: (spaceId: string) => void;
  onRenameChat?: (chat: MinimizedChat) => void;
  onRenameSpace?: (space: Space) => void;
}

const SidebarItemDropdown: React.FC<SidebarItemDropdownProps> = ({ chat, space, onPinToggle, onDeleteChat, onDeleteSpace, onRenameChat, onRenameSpace }) => {
  const handleAction = useCallback((action: 'pin' | 'delete' | 'rename') => {
    if (action === 'pin' && onPinToggle && chat) {
      onPinToggle(chat.id);
    } else if (action === 'delete' && (onDeleteChat || onDeleteSpace)) {
      if (chat) {
        onDeleteChat?.(chat.id);
      } else if (space) {
        onDeleteSpace?.(space.id);
      }
    } else if (action === 'rename' && (onRenameChat || onRenameSpace)) {
      if (chat) {
        onRenameChat?.(chat);
      } else if (space) {
        onRenameSpace?.(space);
      }
    }
  }, [chat, space, onPinToggle, onDeleteChat, onDeleteSpace, onRenameChat, onRenameSpace]);

  return (
    <div className="chat-dropdown-container">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            className="chat-menu-btn"
            aria-label={`More actions for ${chat?.title || space?.title || 'Untitled chat'}`}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <EllipsisIcon aria-hidden className="shrink-0" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" side="bottom">
          {onPinToggle && chat && (
            <DropdownMenuRow
              icon={(
                <PinIcon
                  color={chat.isPinned ? "#FFB800" : undefined}
                  fill={chat.isPinned ? "#FFB800" : "none"}
                />
              )}
              text={chat.isPinned ? 'Unpin' : 'Pin'}
              action={() => handleAction('pin')}
            />
          )}
          {onRenameChat && chat && (
            <DropdownMenuRow
              icon={<PencilIcon />}
              text="Rename"
              action={() => handleAction('rename')}
            />
          )}
          {onRenameSpace && space && (
            <DropdownMenuRow
              icon={<PencilIcon />}
              text="Rename"
              action={() => handleAction('rename')}
            />
          )}
          {(onDeleteChat && chat) || (onDeleteSpace && space) ? (
            <DropdownMenuRow
              icon={<Delete02Icon />}
              text={space ? 'Delete Space' : 'Delete Chat'}
              action={() => handleAction('delete')}
            />
          ) : null}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default SidebarItemDropdown;
